<template>
  <van-nav-bar title="停餐记录" left-text="返回" left-arrow @click-left="onClickLeft" />
  <van-empty v-if="listSize == 0" description="暂无内容" />
  <div v-if="listSize > 0" style="margin-bottom: 40px">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="20"
      @load="onLoad"
    >
      <van-cell-group
        inset
        v-for="item in list"
        :key="item.payment_id"
        style="margin-top: 5px"
      >
      <van-cell :title="item.create_time" />
        <van-cell :title="item.company_name" />
        <van-cell :title="'停餐日期:' +item.absence_request" />
        <van-cell :title="'停餐原因: ' +'家中有事'" />
        <van-cell :title="'审核状态: ' + getStatusText(item.review_status)" />
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    // const Route = useRoute(); //获取到值
    const router = useRouter(); //路由传值
    const listSize = ref(1);

    onMounted(() => {
    });

    const onLoad = () => {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
      finished.value = false;
      loading.value = true;
      api
        .getAbsenceRequest({
          child_id: localStorage.getItem("childId"),
        })
        .then((res) => {
          if (res.data.code == 34515) {
            let result = res.data.result;
            let dayList = result;
            for (let i = 0; i < dayList.length; i++) {
              list.value.push(dayList[i]);
            }
            listSize.value = list.value.length;
            // 加载状态结束
            loading.value = false;

            // 数据全部加载完成
            finished.value = true;
          } else {
            listSize.value = 0;
            finished.value = true;
          }
        })
        .catch((err) => {
          finished.value = true;
          listSize.value = 0;
          Toast(err.message);
        });
    };

    const onClickLeft = () => {
      router.go(-1);
    };
    const getStatusText = (status)=> {
      switch (status) {
        case 0:
          return '未审核';
        case 1:
          return '已审核';
        case 2:
          return '驳回';
        default:
          return '未知状态';
      }
    }
    
    return {
      list,
      onLoad,
      loading,
      finished,
      listSize,
      onClickLeft,
      getStatusText,
    };
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.container span:first-child {
  flex: 1;
  text-align: left;
}

.container span:last-child {
  flex: 0 0 auto;
  text-align: right;
}

.clickable {
  cursor: pointer; /* 可点击的鼠标指针 */
}

.clickable.disabled {
  cursor: not-allowed; /* 不可点击的鼠标指针 */
  opacity: 0.5; /* 降低透明度表示不可点击 */
  pointer-events: none; /* 阻止点击事件 */
}
</style>
